import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import PageCaption	                      from '@/components/PageCaption.vue';
import InstitutionalIdentificationSectionView from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionView.vue';
import InstitutionalIdentificationSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionEdit.vue';
import InstitutionalFormatSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalFormatSectionEdit.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue'
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { onMounted, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageInstitutionalEdit',
  setup(__props) {

const accordionRef = ref<any>(null)



const institutionalStore = useInstitutionalStore();
const router = useRouter();

const route = useRoute();

const institutionalId = computed(() => Number(route.params.id));


/*onMounted(async () => {
  const from = sessionStorage.getItem('from');

  if (!from) {
    router.push({ name: 'home' });
    return;
  }

  sessionStorage.removeItem('from');

  // ✅ AQUI ESTÁ O QUE FALTAVA
  if (institutionalId.value) {
    await institutionalStore.fetchInstitutionalById(institutionalId.value);
  }
});*/

onMounted(async () => {
  const from = sessionStorage.getItem('from');

  if (!from) {
    router.push({ name: 'home' });
    return;
  }

  sessionStorage.removeItem('from');

  // ✅ Se vem de 'review', não recarrega (preserva alterações)
  if (from === 'review') {
    return
  }

  // ✅ Se vem de outro lugar, recarrega normalmente
  if (!institutionalStore.institutionalDetail && institutionalId.value) {
    await institutionalStore.fetchInstitutionalById(institutionalId.value);
  }
});






/*const institutionalEditData = computed(() => {
  const detail = institutionalStore.institutionalDetail;

  if (!detail) return null;

  const imagens = detail.imagens || [];

  return {
    ...detail,
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1 },
        { id: 2, tela: 'Tela 2', posicao: 2 },
        { id: 3, tela: 'Tela 3', posicao: 3 },
        { id: 4, tela: 'Tela 4', posicao: 4 }
      ],
      telasAtm: [
        { id: 8, botao: 'Botão 1', posicao: 8 },
        { id: 9, botao: 'Botão 2', posicao: 9 }
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],

      // ✅ ESSENCIAL
      imagens: imagens
    }
  };
});*/

const institutionalEditData = computed(() => {
  const detail = institutionalStore.institutionalDetail;

  if (!detail) return null;

  const imagens = detail.imagens || [];

   const mapTempo = (posicao: number) => {
    const img = imagens.find((i: any) => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }

  const temImagem = (posicoes: number[]) => 
        imagens.some(img => posicoes.includes(img.posicaoImagem))

  return {
    ...detail, // ✅ já tem id aqui
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        /* { id: 8, botao: 'Botão 1', posicao: 8 },
        { id: 9, botao: 'Botão 2', posicao: 9 },
        { id: 10, botao: 'Botão 3', posicao: 10 },
        { id: 11, botao: 'Botão 4', posicao: 11 }*/
         { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
         { id: 9, botao: 'Recarga celular', posicao: 9 },
         { id: 10, botao: 'Mais serviços', posicao: 10 },
         { id: 11, botao: 'Depositar dinheiro', posicao: 11 },
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],
      imagens: imagens,
      corTexto: detail.corTexto ?? null,
      exibeTelaAbertura: detail.exibeTelaAbertura ?? true,

      alterarTelaInicial: temImagem([1,2,3,4,8,9,10,11]),
      alterarTelaAguarde: temImagem([6,7]),

      alterarTelaAbertura: (
        temImagem([5]) || detail.exibeTelaAbertura
      )
    }
  };
});






return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!

  return (_unref(institutionalStore).institutionalDetail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_c_q_separator, {
            class: "q-pb-lg",
            withBackButton: true
          }),
          _createVNode(PageCaption, {
            pageCaptionTitle: "Editar Cadastro Institucional",
            pageCaptionDescription: ""
          }),
          _createVNode(InstitutionalIdentificationSectionView, {
            institutionalData: _unref(institutionalStore).institutionalDetail
          }, null, 8, ["institutionalData"]),
          _createVNode(_component_c_q_separator, { class: "q-pt-lg q-pb-lg" }),
          _createVNode(InstitutionalIdentificationSectionEdit),
          _createVNode(InstitutionalFormatSectionEdit),
          _createVNode(_component_c_q_separator, { class: "q-my-md" }),
          (institutionalEditData.value)
            ? (_openBlock(), _createBlock(InstitutionalAccordion, {
                key: 0,
                ref_key: "accordionRef",
                ref: accordionRef,
                accordionsData: institutionalEditData.value.accordions,
                mode: "edit"
              }, null, 8, ["accordionsData"]))
            : _createCommentVNode("", true),
          _createVNode(InstitutionalActionButtonsSection, {
            propShowBtnReviewFocusedCampaign: true,
            accordionRef: accordionRef.value
          }, null, 8, ["accordionRef"]),
          _createVNode(_component_c_q_separator, { class: "q-my-md" })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})